import { fillText } from './utils';

const pad = (n) => (n < 10 ? `0${n}` : String(n));

/*
Odliczanie do pierwszego gwizdka w linijce z datą meczu. Gra nie zamyka się z gwizdkiem
(kończy ją dopiero wyczerpanie puli), więc po rozpoczęciu meczu cała dopiska
"do pierwszego gwizdka" znika - `wrap` to jej element.
*/
export function startCountdown(el, wrap, tipoff, texts) {
    if (!el) {
        return;
    }

    let timer = null;

    const tick = () => {
        const ms = tipoff - Date.now();

        if (ms <= 0) {
            if (wrap) {
                wrap.hidden = true;
            }

            clearInterval(timer);

            return;
        }

        const d = Math.floor(ms / 864e5);
        const h = Math.floor(ms / 36e5) % 24;
        const m = Math.floor(ms / 6e4) % 60;
        const s = Math.floor(ms / 1e3) % 60;
        const days = d ? fillText(texts.countdown_days, { days: d }) : '';

        el.textContent = `${days}${pad(h)}:${pad(m)}:${pad(s)}`;
    };

    timer = setInterval(tick, 1000);
    tick();
}
